'use client'

// components
import Nav from '@/components/Nav'
import Callout from "@/components/Callout";
import Footer from '@/components/Footer';

// blocks
import Header from '@/blocks/Header'
import IconGrid from "@/blocks/IconGrid";
import SchemaLess from "@/blocks/SchemaLess";
import CodeExample from "@/blocks/CodeExample";
import TwoColumnFeatures from "@/blocks/TwoColumnFeatures";
import Embeddable from "@/blocks/Embeddable";
import DeveloperKit from "@/blocks/DeveloperKit";
import FeatureGrid from "@/blocks/FeatureGrid";
import Pricing from '@/blocks/Pricing';

export default function Home() {
  return (
    <div style={{ maxWidth: 'var(--MaxWidth)', margin: '0 auto' }}>
      <Nav/>
      <main>
        <Header/>
        <IconGrid/>
        {/* <Callout>Indx connects keywords and finds what traditional search engines miss.</Callout> */}
        <Callout>Indx uses a fundamentally better matching model: Identifying patterns in text instead of relying solely on exact word matches</Callout>
        <TwoColumnFeatures>
          <Embeddable/>
          <DeveloperKit/>
        </TwoColumnFeatures>
        <SchemaLess/>
        <CodeExample/>
        <Callout>Handle more real-world search behaviour with far less tuning</Callout>
        <FeatureGrid/>
        <Pricing/>
      </main>
      <Footer/>
    </div>
  );
}

